import { inject, Injectable } from '@angular/core';
import { Params, Router } from '@angular/router';
import { AuthRouteSegments } from '../../constants';

@Injectable({
  providedIn: 'root',
})
export class RedirectHelperService {
  private readonly router = inject(Router);

  // TODO - Hybrid App - confirm with the FinPay team once old payments are decomissioned
  redirectToLoginPage(queryParams: Params = {}, replaceUrl = false): void {
    this.router.navigate(['/', AuthRouteSegments.login], {
      queryParams,
      replaceUrl,
    });
    // this.redirectWithReload("/Login", queryParams, replaceUrl);
  }

  // redirectWithReload(path: string, queryParams: Params = {}, replaceUrl = false) {
  //   const url = this.location.prepareExternalUrl(path); // prepare external url adds the base href to the url

  //   const queryString = new URLSearchParams(queryParams).toString();

  //   const finalUrl = queryString ? `${url}?${queryString}` : url;

  //   if (replaceUrl) {
  //     this.windowRef.location.replace(finalUrl);
  //   }
  //   else {
  //     this.windowRef.location.href = finalUrl;
  //   }
  // }
}
